<template>
<div>
    <el-tooltip class="item" placement="bottom">
        <div slot="content">
            <h6 class="regular">
                As fichas são disponibilizadas em arquivos .zip e podem ser acessadas com<br>
                o uso de programas como 7-Zip e WinRaR.
            </h6>
        </div>
        <h6 :class="`c-nmidone regular mb-0`">
            Como abrir arquivos .zip
            <Question class="ml-1" color="#A1A8B8"/>
        </h6>
    </el-tooltip>
</div>
</template>

<script>
import Question from '@/components/icons/Question'
export default {
    components: {
        Question
    }
}
</script>

<style>

</style>